import type { JellyfinItem } from '../api/jellyfin';

export type HomeWatchRows = {
  continueWatching: JellyfinItem[];
  nextUp: JellyfinItem[];
  combined: JellyfinItem[];
};

export const MINIMUM_RESUME_TICKS = 60 * 10_000_000;

export function buildHomeWatchRows(
  resumeItems: JellyfinItem[],
  nextUpItems: JellyfinItem[],
  limit: number,
): HomeWatchRows {
  const continueWatching = resumeItems
    .filter((item) =>
      !item.UserData?.Played &&
      (item.UserData?.PlaybackPositionTicks ?? 0) >= MINIMUM_RESUME_TICKS,
    )
    .sort(
      (left, right) =>
        Date.parse(right.UserData?.LastPlayedDate ?? '') -
        Date.parse(left.UserData?.LastPlayedDate ?? ''),
    )
    .slice(0, limit);
  const nextUp = nextUpItems
    .filter((item) =>
      !item.UserData?.Played &&
      (item.UserData?.PlaybackPositionTicks ?? 0) < MINIMUM_RESUME_TICKS,
    )
    .slice(0, limit);
  const seen = new Set<string>();
  const combined = [...continueWatching, ...nextUp]
    .filter((item) =>
      Boolean(item.Id) && !seen.has(item.Id!) && Boolean(seen.add(item.Id!)),
    )
    .slice(0, limit);
  return { continueWatching, nextUp, combined };
}
